import filesize from "filesize";
import {UilTrashAlt} from "@iconscout/react-unicons";

export default function DocumentCard({doc, deleteFile}) {
    const NameContainer = ({children}) => <>
        {doc.id ? <a href={process.env.REACT_APP_API_URL + '/documents/' + doc.path}
                     target="_blank"
                     rel="noopener noreferrer"
                     download>{children}</a>

            : <span>{children}</span>}
    </>

    return (
        <li className="depot-editor-documents-document">
            <UilTrashAlt onClick={() => deleteFile(doc)} title="Supprimer"/>
            <NameContainer>{doc.name} ({filesize(doc.size)})</NameContainer>
        </li>
    )
}
